import Vue from 'vue'
import { Component, Prop, Watch } from 'vue-property-decorator'
import TreeViewItem from './TreeViewItem.vue';
import { createEventBus, getGUID } from '../../util';

declare global {
    namespace treeView {
        export type TreeViewItem<T> = {
            id: number | string;
            parentId: number | string | null;
            displayName: string;
            childs: TreeViewItem<T>[] | null;
            expanded?: boolean;
            current?: boolean;
            context: T
        }
    }
}

@Component({
    components: {
        TreeViewItem
    }
})
export default class TreeView  extends Vue {
    @Prop({ type: Array }) model!: treeView.TreeViewItem<any>[];    

    treeRoots: treeView.TreeViewItem<any>[] = [];
    treeViewId: string = `treeview-${getGUID(false)}`;
    expandmap: (string | number)[] = [];

    @Watch('model')
    onRootChanged(newVal: treeView.TreeViewItem<any>[]) {
        this.expandmap = [];
        var preCurrent = newVal.find(n => n.current);

        if(preCurrent) {
            this.createExpandMap(preCurrent, newVal);
        }

        var root = newVal.filter(m => m.parentId == null);
        this.treeRoots = this.buildTree(root, newVal);
    }

    created() {        
        createEventBus(window, this.treeViewId, this.onTreeItemSelected)
        this.onRootChanged(this.model);
    }

    buildTree(parents: treeView.TreeViewItem<any>[], source: treeView.TreeViewItem<any>[]): treeView.TreeViewItem<any>[] {
        parents.forEach(p => {
            p.expanded = this.expandmap.findIndex(e => e === p.id) >= 0;
            var childs = source.filter(s => s.parentId == p.id);   
            
            if(childs.length > 0) {
                p.childs = this.buildTree(childs, source);
            } else {
                p.childs = [];
            }
        });

        return parents;
    }

    createExpandMap(node: treeView.TreeViewItem<any>, list: treeView.TreeViewItem<any>[]) {
        this.expandmap.push(node.id);

        if(node.parentId != null) {
            var parentNode = list.find(n => n.id === node.parentId) || null;
            
            if(parentNode != null) {
                this.createExpandMap(parentNode, list);
            }
        }
    }

    onTreeItemSelected(data: any) {    
        this.$emit('selected', data);
    }   
}